export const USER_CHAT_QUERY_ENDPOINT = "api/user/query";
export const USER_CHAT_RISKCHECKER_ENDPOINT = "api/riskchecker?project_id=2";
export const USER_CHAT_GET_GOVT_RULES_ENDPOINT =
  "api/government-rules?project_id=2";
export const USER_CHAT_GET_REAL_ACC_ENDPOINT = "api/real-accident?project_id=2";
export const USER_CHAT_GET_IMAGES_DESC_ENDPOINT =
  "api/image-description?project_id=2";
export const PDF_PREVIEW = "api/pdf/preview";
export const PDF_URL = "api/url";
